module.exports = __webpack_public_path__ + "static/media/mohren-loader-weiss.6f2e5880.gif";